<template>
  <div class="c-content">
    <div class="c-content-wrap" @click="handleHref">
      <div class="c-content-html" v-html="finalContent" :style="{ color }"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    content: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '#676767',
    },
  },
  components: {},
  data() {
    return {};
  },
  computed: {
    finalContent() {
      let { content } = this;
      content = content.replace(/(<img[^>]+>)/g, (match) => match.replace(/height="[\d]+[\\.]?[\d]*"/g, ''));
      content = content.replace(/(<table[^>]+>)/g, (match) => match.replace(/height="[\d]+[\\.]?[\d]*"/g, ''));
      content = content.replace(/(<video[^>]+>)/g, (match) =>
        match
          .replace(/controls=""/, '')
          .replace(
            />/,
            ' controls="" playback-rate="1" x5-playsinline="true" playsinline="true" webkit-playsinline="true" x-webkit-airplay="allow" x5-video-orientation="portrait" preload="true" autoplay style="object-fit: scale-down;min-width: 100%;width:100%;min-height:232px;height: auto;">'
          )
      );
      return content;
    },
  },
  methods: {
    getUrl(src) {
      console.log(src);
      if (!src) return '';
      if (!/^http/.test(src)) return;
      const width = this.width ? `,w_${this.width}` : '';
      const height = this.height ? `h_${this.height}` : '';
      return `${src.split('?')[0]}?x-oss-process=video/snapshot,t_100${width}${height},f_jpg,m_fast&t=${new Date().getTime()}`;
    },
    getElementByTag(e, tagName = 'A') {
      let target = e.target;
      while (target.tagName && target.tagName.toUpperCase() !== tagName && target.parentNode != null) {
        target = target.parentNode;
      }
      if (!target.tagName) return null;
      return target;
    },
    getElementByClass(e, className = 'A') {
      let target = e.target;
      while (target.getAttribute && !(target.getAttribute('class') || '').split(' ').some((classNameItem) => classNameItem.trim() === className) && target.parentNode != null) {
        target = target.parentNode;
      }
      if (!target.tagName) return null;
      return target;
    },
    handleHref(e) {
      if (this.getElementByTag(e, 'A')) {
        const target = this.getElementByTag(e, 'A');
        const tagName = target.tagName.toUpperCase();
        const href = target.getAttribute('href');
        const patternHref = /^https:\/\/h5(-test)?\.zeeho.com/;
        if (tagName === 'A' && (href.startsWith('https://') || href.startsWith('http://'))) {
          if (patternHref.test(href)) {
            e.preventDefault();
            e.stopPropagation();
            const path = href.replace(patternHref, '');
            this.$router.push({ path });
            return;
          } else {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = href;
            // this.$router.push({ name: 'webview', query: { src: href, hideTitle: true } });
            return;
          }
        }
        return;
      }
      if (this.getElementByTag(e, 'IMG')) {
        console.log('DAU');
        console.log(this.allImage);
        const target = this.getElementByTag(e, 'IMG');
        console.log(target);
        const url = target.getAttribute('src');
        console.log(url);
        const href = target.getAttribute('data-href');
        if (href && href.startsWith('http')) {
          // this.$router.push({ name: 'webview', query: { src: href, hideTitle: true } });
          window.location.href = href;
          return;
        }
        this.preivewImage.startPosition = this.allImage.findIndex((src) => url === src);
        this.preivewImage.images = this.allImage;
        this.preivewImage.visible = true;

        return;
      }
      if (this.getElementByClass(e, 'section-video')) {
        e.preventDefault();
        e.stopPropagation();
        const target = this.getElementByClass(e, 'section-video').querySelector('video');
        const url = target.getAttribute('src');
        const type = `video/${url.slice(url.lastIndexOf('.') + 1)}`;
        this.previewVideoOptions.type = type;
        this.previewVideoOptions.src = url;
        // console.log(this.isApp);
        // this.previewVideoOptions.visible = true;

        if (this.isApp) {
          let poster = this.getUrl(url);
          console.log('分享');
          console.log(window.zeeho);
          window.zeeho.previewMedia({
            type: 'video',
            sources: [
              {
                url,
                poster,
              },
            ],
          });
        } else {
          this.previewVideoOptions.visible = true;
        }
      }
    },
  },
  created() {},
  mounted() {},
  beforeUnmount() {},
  watch: {},
};
</script>
<style lang="scss">
.c-content {
  flex: 1;
  margin: 0 auto;
  width: 100%;
  text-align: left;
  color: #101010;
  font-family: PingFangSC-Regular, PingFang SC;
  word-break: break-all;
  .c-content-wrap {
    width: 100%;
  }
  .c-content-html {
    width: 100%;
    line-height: 1.5;
    font-size: 14px;
    font-weight: 400;
    color: #676767;
    text-align: left;
    word-wrap: break-word;
  }
  pre {
    white-space: pre-wrap;
  }
  p {
    margin: 0;
    font-size: 14px;
    font-weight: 300;
  }
  img {
    max-width: 100%;
    width: 100%;
    vertical-align: top;
  }
  table {
    max-width: 100vw;
  }
  .ql-align-center {
    text-align: center;
  }
  .ql-align-right {
    text-align: right;
  }
  .ql-container.ql-snow {
    border: none !important;
  }
  .ql-snow .ql-editor h1 {
    font-size: 24px;
  }
  .ql-snow .ql-editor h2 {
    font-size: 22px;
  }
  .ql-snow .ql-editor h3 {
    font-size: 20px;
  }
  .ql-snow .ql-editor h4 {
    font-size: 18px;
  }
  .ql-snow .ql-editor h5 {
    font-size: 16px;
  }
  .ql-snow .ql-editor h6 {
    font-size: 14px;
  }
  .ql-snow .ql-editor p {
    font-size: 16px;
  }
  .ql-snow .ql-editor .ql-size-small {
    font-size: 14px;
  }
  .ql-snow .ql-editor .ql-size-large {
    font-size: 18px;
  }
  .ql-snow .ql-editor .ql-size-huge {
    font-size: 20px;
  }
  .ql-snow .ql-align-center {
    text-align: center;
  }
  .ql-container.ql-snow {
    border: none !important;
  }
}
</style>
